import { render, staticRenderFns } from "./EditorDeLayoutDeEtiqueta.vue?vue&type=template&id=a9251952&scoped=true&"
import script from "./EditorDeLayoutDeEtiqueta.vue?vue&type=script&lang=ts&"
export * from "./EditorDeLayoutDeEtiqueta.vue?vue&type=script&lang=ts&"
import style0 from "./EditorDeLayoutDeEtiqueta.vue?vue&type=style&index=0&id=a9251952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9251952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCard,VCardText,VCheckbox,VCol,VIcon,VRow,VSlider})
